import React from "react";
import BaseDropdown from "./BaseDropdown";

interface DropdownOption {
    value: number;
    label: string;
}

interface IDDropdownProps {
    label: string;
    options: DropdownOption[];
    selectedValue: number | null;
    onChange: (value: number | null) => void;
    placeholder?: string;
    loading?: boolean;
    disabled?: boolean;
    required?: boolean;
}

const IDDropdown: React.FC<IDDropdownProps> = ({
                                                   label,
                                                   options,
                                                   selectedValue,
                                                   onChange,
                                                   placeholder,
                                                   loading,
                                                   disabled,
                                                   required,
                                               }) => {
    const handleChange = (value: string | number | null) => {
        if (typeof value === "number" || value === null) {
            onChange(value); // Pass only number or null to onChange
        }
    };

    return (
        <BaseDropdown
            label={label}
            options={options}
            selectedValue={selectedValue}
            onChange={handleChange}
            placeholder={placeholder}
            loading={loading}
            disabled={disabled}
            required={required}
        />
    );
};

export default IDDropdown;
